import { createApp, h } from 'vue'
import ExportToPdf from './ExportToPdf.vue'

async function loadHtml2Pdf() {
    const html2pdf = await import('html2pdf.js');
    return html2pdf.default;
}

const renderComponentToDom = async (component: any, props: Record<string, boolean>) => {
  return new Promise<HTMLElement>((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const app = createApp({
      render() {
        return h(component, props);
      },
      mounted() {
        resolve(container);
      },
      unmounted() {
        document.body.removeChild(container);
      },
    });

    app.mount(container);
  });
};

export const exportComponentToPdf = async (fileName: string, props: Record<string, boolean> ) => {
    try {
      const html2pdf = await loadHtml2Pdf();
      const container = await renderComponentToDom(ExportToPdf, props);

      const { useThemeStore } = await import('@/stores');

      const themeStore = useThemeStore()

      const capsuleElements = container.getElementsByClassName('pdf')

      for (let i = 0; i < capsuleElements.length; i++) {
        const element = capsuleElements[i] as HTMLElement;
        element.style.backgroundColor = themeStore.themeColors.colorBackground;
      }
    
      const options = {
        margin: 0.25,
        filename: `${fileName}.pdf`,
        image: {
          type: 'jpeg' as const,
          quality: 0.98
        },
        html2canvas: { scale: 1 },
        jsPDF: {
          unit: 'in',
          format: [16, 9.15] as [number,number],
          orientation: 'landscape' as const
        },
      };
  
      setTimeout(() => {
        html2pdf()
          .set(options)
          .from(container)
          .save()
          .then(() => {
            console.log(`PDF "${fileName}.pdf" has been successfully created and downloaded.`);
          })
          .catch((error: unknown) => {
            if (error instanceof Error) {
              console.error('An error occurred while generating the PDF:', error.message);
            } else {
              console.error('An unknown error occurred:', error);
            }
          })
          .finally(() => {
            container.remove();
          });
      }, 1000);
    } catch (error) {
      console.error('An error occurred during the export process:', error);
    }
};
  